import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { FaCheck, FaCheckCircle, FaExclamationTriangle, FaSignInAlt, FaSignOutAlt } from 'react-icons/fa';
import { logout } from '../../../Redux/Auth/authActions';
import { HELIXOPS_EMAIL_DOMAIN, PENDING_HELIX_EMAIL_FALLBACK, PENDING_HELIX_EMAIL_KEY } from '../../../Constants/emailMigration';

const WHATS_NEW_SHOWN_THIS_SESSION_KEY = 'whatsNewShownThisSession';

const clearEmailMigrationSessionKeys = () => {
  sessionStorage.removeItem(PENDING_HELIX_EMAIL_KEY);
  sessionStorage.removeItem(WHATS_NEW_SHOWN_THIS_SESSION_KEY);
};

const EmailUpdated = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const pendingEmail = sessionStorage.getItem(PENDING_HELIX_EMAIL_KEY);
  const emailLabel = pendingEmail || PENDING_HELIX_EMAIL_FALLBACK;
  const isAlreadyCompleted = Boolean(location.state?.alreadyCompleted);

  const handleLogoutNow = () => {
    clearEmailMigrationSessionKeys();
    dispatch(logout());
  };

  return (
    <main className="update-email-page email-updated-page">
      <section className="update-email-panel" aria-labelledby="email-updated-title">
        <div className={`update-email-hero-icon ${isAlreadyCompleted ? 'update-email-hero-icon--warning' : 'update-email-hero-icon--success'}`} aria-hidden="true">
          {isAlreadyCompleted ? <FaExclamationTriangle /> : <FaCheck />}
        </div>

        <h1 id="email-updated-title" className="update-email-title">
          {isAlreadyCompleted ? 'Email Already Updated' : 'Email Updated Successfully'}
        </h1>
        <p className="update-email-subtitle">
          {isAlreadyCompleted
            ? `Your email has already been updated to your ${HELIXOPS_EMAIL_DOMAIN} account`
            : 'Your email has been updated successfully'}
        </p>

        <div className="email-updated-card">
          {!isAlreadyCompleted && (
            <div className="email-updated-message-box email-updated-success-box">
              <span className="email-updated-message-icon" aria-hidden="true">
                <FaCheckCircle />
              </span>
              <div>
                <h2 className="email-updated-message-title">Verification Complete</h2>
                <p className="email-updated-message-text">
                  Your email address has been verified and updated to {emailLabel}.
                </p>
              </div>
            </div>
          )}

          <div className="email-updated-message-box email-updated-info-box">
            <span className="email-updated-message-icon" aria-hidden="true">
              <FaSignInAlt />
            </span>
            <div>
              <h2 className="email-updated-message-title">Next Step Required</h2>
              <p className="email-updated-message-text">
                {isAlreadyCompleted
                  ? `Please log out and sign in again using your new ${HELIXOPS_EMAIL_DOMAIN} email.`
                  : `Please log out and sign in again using ${emailLabel} to continue.`}
              </p>
            </div>
          </div>
        </div>

        <div className="email-updated-actions" aria-label="Email updated actions">
          <button
            type="button"
            className="email-updated-action email-updated-action--primary"
            onClick={handleLogoutNow}
          >
            <FaSignOutAlt aria-hidden="true" />
            Log Out Now
          </button>
        </div>
      </section>
    </main>
  );
};

export default EmailUpdated;
